import { documentDefinitions } from '../documents';

export const MODEL_CATEGORIES = [
  { id: 'corretores', label: 'Corretores' },
];

const categoryLabelById = Object.fromEntries(
  MODEL_CATEGORIES.map((category) => [category.id, category.label])
);

/**
 * All system models derived from documentDefinitions.
 * Extend category mapping here when new professions are added.
 */
export function getSystemModels() {
  return Object.values(documentDefinitions).map((def) => ({
    id: def.id,
    name: def.label,
    category: 'corretores',
  }));
}

export function getSystemModelsByCategory(categoryId) {
  if (!categoryId) return getSystemModels();
  return getSystemModels().filter((model) => model.category === categoryId);
}

export function getCategoryLabel(categoryId) {
  return categoryLabelById[categoryId] ?? categoryId;
}

export function getCategorySelectOptions() {
  return MODEL_CATEGORIES.map((category) => ({
    value: category.id,
    label: category.label,
  }));
}
